exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".markunread[data-v-33fdb5b8]:hover{color:var(--v-primary-base)!important}", ""]);

// exports
